<template>
  <div class="account-row plans">
    <div class="row">
      <template v-if="user.connectsTo == 0">
        <CurrentLicense/>
        <NextBilling v-if="showBillingInfo"/>
        <PaymentMethod v-if="showBillingInfo"/>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CurrentLicense from './CurrentLicense'
import NextBilling from './NextBilling'
import PaymentMethod from './PaymentMethod'

export default {
  data() {
    return {

    }
  },
  methods: {
    
  },
  computed: {
    ...mapGetters({
      user: 'user/data',
    }),

    showBillingInfo() {
      return this.user.plan && this.user.subsPlan && this.user.subsPlan !== 'impact'
    }
  },
  components: {
    CurrentLicense,
    NextBilling,
    PaymentMethod,
  }
}
</script>

<style lang="scss" scoped>
.plans {
  padding-top: 10px;
  border: 0 !important;

  .row {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: flex-start;
  }

  .stats {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    width: 100%;
  }
  .heading {
    h2 {
      flex-grow: 1;
      span {
        color: $mainGreen;
      }
    }
  }
}
</style>
